export default function(response, vueInstance) {
    if (response.data.success !== true) {
        vueInstance.$emit('error');

        return;
    }

    vueInstance.$emit('authenticated', response.data.user);

    if (!vueInstance.redirect.length) {
        return;
    }

    if (vueInstance.redirect === 'reload') {
        window.location.reload();

        return;
    }

    window.location.href = vueInstance.redirect;
};



// WEBPACK FOOTER //
// ./src/Assets/components/Users/LoginOrSignup/mixins/loginResponse.js